import React from 'react';
import { useNavigate } from 'react-router-dom';
export function LandingPage() {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-gradient-to-br from-navy via-navy-light to-navy flex flex-col" data-id="element-535">
      {/* Logo - Center Top */}
      <div className="pt-6 md:pt-8 pb-3 md:pb-4 flex justify-center" data-id="element-536">
        <img src="https://cdn.magicpatterns.com/uploads/jrZpZA6KS7cefrnJNRcqNs/Copy_of_HIRE.png" alt="HIRE" className="h-10 md:h-16" data-id="element-537" />
      </div>

      {/* Main Content - Centered */}
      <div className="flex-1 flex items-center justify-center px-4 py-8 md:py-12" data-id="element-538">
        <div className="max-w-4xl w-full text-center" data-id="element-539">
          {/* Small Headline Above */}
          <p className="text-sm md:text-base text-amber font-semibold mb-3 md:mb-4 uppercase tracking-wide" data-id="element-540">
            For D2D Roofing CEOs Only...
          </p>

          {/* Headline */}
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-4 md:mb-6" data-id="element-541">
            Calculate Your Recruiting ROI in{' '}
            <span className="relative inline-block" data-id="element-542">
              <span className="relative z-10 px-2" data-id="element-543">60 Seconds</span>
              <span className="absolute inset-0 -inset-x-3 bg-amber animate-highlight-once rounded-full" data-id="element-544"></span>
            </span>
          </h1>

          {/* Sub-headline */}
          <p className="text-base md:text-xl lg:text-2xl text-blue-100 leading-relaxed mb-6 md:mb-8 max-w-3xl mx-auto" data-id="element-545">
            See exactly how your RECRUITING translates into REVENUE. Get your
            custom 12-month roadmap with just a few clicks.
          </p>

          {/* Trust Indicators */}
          <div className="mb-6 md:mb-8 flex flex-wrap items-center justify-center gap-4 md:gap-8 text-blue-200 text-xs md:text-sm" data-id="element-546">
            <div className="flex items-center gap-2" data-id="element-547">
              <svg className="w-4 h-4 md:w-5 md:h-5" fill="currentColor" viewBox="0 0 20 20" data-id="element-548">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-549" />
              </svg>
              <span data-id="element-550">Takes less than 60 seconds</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-551">
              <svg className="w-4 h-4 md:w-5 md:h-5" fill="currentColor" viewBox="0 0 20 20" data-id="element-552">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-553" />
              </svg>
              <span data-id="element-554">Instant results</span>
            </div>
          </div>

          {/* Preview Image */}
          <div className="mb-8 md:mb-12 rounded-lg overflow-hidden shadow-2xl max-w-3xl mx-auto border-2 border-white/10" data-id="element-555">
            <img src="https://cdn.magicpatterns.com/uploads/aVC5v9kvqB7Vnt2MJtqRx7/Screenshot_2025-12-26_at_11.55.57_PM.png" alt="ROI Calculator Preview" className="w-full h-auto" data-id="element-556" />
          </div>

          {/* CTA Button */}
          <button onClick={() => navigate('/calculator')} className="group relative inline-flex items-center gap-2 md:gap-3 px-6 md:px-8 py-4 md:py-5 bg-amber hover:bg-amber-dark text-navy font-bold text-lg md:text-xl rounded-lg transition-all shadow-2xl hover:shadow-amber/50 hover:scale-105 active:scale-100" data-id="element-557">
            <span data-id="element-558">Start Your Free ROI Analysis</span>
            <svg className="w-5 h-5 md:w-6 md:h-6 transition-transform group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-559">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M13 7l5 5m0 0l-5 5m5-5H6" data-id="element-560" />
            </svg>
          </button>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-navy border-t-2 border-white/10" data-id="element-561">
        <div className="max-w-7xl mx-auto px-4 py-6 md:py-8" data-id="element-562">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-563">
            <img src="https://cdn.magicpatterns.com/uploads/jrZpZA6KS7cefrnJNRcqNs/Copy_of_HIRE.png" alt="HIRE" className="h-8" data-id="element-564" />
            <div className="flex flex-wrap items-center justify-center gap-6 text-sm text-blue-200" data-id="element-565"></div>
          </div>
        </div>
      </footer>
    </div>;
}